export default __webpack_public_path__ + "static/flowers-right-02f30c59a56a8b9d05d00d5871017a8a.png";